module.exports = __webpack_public_path__ + "static/media/29DUNON15.ffea45f9.jpg";